import { Component, OnInit, Input } from '@angular/core';

const DefaultOptions = {
  bar: {
    scales: {
      xAxes: [
        {
          stacked: true,
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
            userCallback: (label, index, labels) => {
              // 소숫점 단위 없애기 위함
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
  },
  line: {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: (label, index, labels) => {
              // 소숫점 단위 없애기 위함
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            autoSkipPadding: 14,
          },
        },
      ],
    },
    legend: {
      display: false,
    },
  },
  pie: {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      position: 'right',
    },
  },
};

const BarChartColor = '74, 119, 187'; // #27c757
const LineChartColor = '74, 119, 187';
const DefaultColors = {
  bar: [
    {
      backgroundColor: `rgba(${BarChartColor},0.4)`,
      borderColor: `rgba(${BarChartColor},0.8)`,
      pointBackgroundColor: `rgba(${BarChartColor},0.4)`,
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: `rgba(${BarChartColor},0.4)`,
    },
  ],
  line: [
    {
      backgroundColor: `rgba(${LineChartColor},0.4)`,
      borderColor: `rgba(${LineChartColor},0.8)`,
      pointBackgroundColor: `rgba(${LineChartColor},0.4)`,
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: `rgba(${LineChartColor},0.4)`,
    },
  ],
};

export interface ChartData {
  datasets: Array<{ label: string; data: number[] }>; // 세로축에 뿌릴 데이터들 ({label: 세로축에 표시된 데이터 이름, data: 세로축 값})
  labels: string[]; // 가로축 이름
}

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class ChartComponent implements OnInit {
  @Input() type: string;
  @Input() data: ChartData;

  constructor() {}

  ngOnInit(): void {}

  get options(): any {
    return DefaultOptions[this.type];
  }

  get colors(): any {
    return DefaultColors[this.type];
  }
}
